import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export const Main = styled('main')(({ theme }) => ({
  marginTop: -160,
  top: '50%',
  position: 'relative',
  width: 'auto',
  display: 'block', // Fix IE 11 issue.
  marginLeft: theme.spacing(3),
  marginRight: theme.spacing(3),
  [theme.breakpoints.up(400 + 8 * 3 * 2)]: {
    width: 400,
    marginLeft: 'auto',
    marginRight: 'auto'
  }
}));

export const Paper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
});

export const CompanyImgCnt = styled('div')({
  height: 100,
  display: 'flex',
  alignItems: 'center'
});

export const CompanyImgLogo = styled('img')({
  height: 100,
  maxWidth: 246
});

export const H5 = styled(Typography)(({ theme }) => ({
  paddingTop: theme.spacing(3)
}));

export const Subtitle1 = styled(Typography)(({ theme }) => ({
  paddingTop: theme.spacing(6)
}));

export const Link = styled('a')({
  textDecoration: 'underline'
});
